<h1 matDialogTitle>Edit {{data.template.template_name}}</h1>

<mat-dialog-content style="max-height: unset;">
  <mat-divider></mat-divider>
  <mat-form-field style="width: 100%;" subscriptSizing="fixed">
    <mat-label>Subject Line</mat-label>
    <input matInput [formControl]="templateControls.subjectLine">
    <mat-error>{{templateControlGroup.controls['subjectLine'].errors | validationMessage }}</mat-error>
  </mat-form-field>

  <br>
  <div class="editor-wrapper" [class.editor-wrapper-loading]="displayEditor === false">
    <mat-spinner *ngIf="displayEditor === false" color="accent"></mat-spinner>
    <editor *ngIf="displayEditor === true"
            [init]="init"
            [formControl]="templateControls.bodyEditor"
    ></editor>
  </div>
  <br>
  <div>
    <mat-form-field class="sent-from-form" subscriptSizing="fixed">
      <mat-label>Sent From Name</mat-label>
      <input matInput [formControl]="templateControls.sentFromName">
    </mat-form-field>
    <mat-form-field class="sent-from-form" style="margin-left: 38px;" subscriptSizing="fixed">
      <mat-label>Sent From Email</mat-label>
      <input matInput [formControl]="templateControls.sentFromEmail">
      <mat-hint>Replies will go to this email.</mat-hint>
      <mat-error>{{templateControlGroup.controls['sentFromEmail'].errors | validationMessage }}</mat-error>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="padding-bottom: 12px;">
    <div style="margin-left: auto">
      <button mat-button type="button" class="white" (click)="onCancelClick()">Cancel</button>
      <button mat-raised-button color="primary" [disabled]="templateControlGroup.invalid" (click)="onSaveClick()">Save</button>
    </div>
</mat-dialog-actions>
